import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SectionAccessGuard implements CanActivate {

  constructor(private userStorageService: UserStorageService,
              private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    for (const menuSection of this.userStorageService.getMenuSectionList()) {
      if (Array.isArray(next.data['optionId'])) {
        if (next.data['optionId'].find(o => menuSection.OptionId)) {
          return true;
        }
      } else {
        if (next.data['optionId'] === menuSection.OptionId) {
          return true;
        }
      }
    }
    this.router.navigate(['/signin']);
    this.userStorageService.deleteAllItems();
    return false;
  }
}
